import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const token = useAuth((s) => s.token);
  const loc = useLocation();
  if (!token) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  return <>{children}</>;
}

export function OwnerOnlyRoute({ children }: { children: React.ReactNode }) {
  const role = useAuth((s) => s.user?.role);
  if (role !== "owner") return <Navigate to="/overview" replace />;
  return <>{children}</>;
}
